var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-button',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],staticClass:"wiki-sidebar-header-toggle",attrs:{"data-testid":"wiki-sidebar-toggle","icon":_vm.icon,"category":"tertiary","title":_vm.title,"aria-label":_vm.title},on:{"click":_vm.toggleWikiSidebar}})
}
var staticRenderFns = []

export { render, staticRenderFns }